import { render, staticRenderFns } from "./ViewTerminal.vue?vue&type=template&id=23d2ef88&scoped=true"
import script from "./ViewTerminal.vue?vue&type=script&lang=js"
export * from "./ViewTerminal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d2ef88",
  null
  
)

export default component.exports